import { getAnalyticTags } from "core/lib/analytics-methods";
import { defaultBannerImage } from "./default-banner-image";
import { defaultChannelImage } from "./default-channel-image";

const LoadingTemplate = `
    <div class="loader-holder">
      <div class="eclipse-loader">
        <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
          <path
            d="M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50"
            fill="#0095da"
            stroke="none"
          ></path>
        </svg>
      </div>
    </div>
  `;

type ButtonLink = {
  url: string;
  text: string;
}

type PopupButtons = {
  primary: ButtonLink,
  secondary: ButtonLink,
  tertiary: ButtonLink
}

export type PopupTemplateData = {
  channelNumber: string;
  channelImageSrc: string;
  header: string;
  bodyText: string;
  buttons: PopupButtons;
  bannerImageSrc: string;
}

export const PopupTemplate = (isLoading: boolean, data?: PopupTemplateData) => {

  const _getTemplate = (mainContent: string) => {
    return `
    <div class="channel-popup-container">
      <div class="channel-popup-overlay"></div>
      <div class="channel-popup-main">
        <div class="channel-popup-header-close">
          <div class="channel-popup-header-close-background"></div>
          <span class="icon-close"></span>
        </div>
        ${mainContent}
      </div>
    </div>
  `.trim();
  }

  if (isLoading) {
    return _getTemplate(LoadingTemplate);
  }

  const getButtonTemplate = (buttonLink: ButtonLink | undefined, nav: string) => {
    if (!buttonLink) {
      return "";
    }

    const { text, url } = buttonLink;

    if (!text || !url) {
      return "";
    }

    const analytics = getAnalyticTags({
      component_name: `channel_visit_${nav}`,
      component_type: "channel_modal",
      nav_item: "channel_details_popup",
      nav_text: nav,
      nav_location: nav,
      channel_name: `${data?.channelNumber}`,
      target_page_url: url
    });

    return `<a class="mb-3" href="${url || ""}" data-component-info=${analytics}>
      <button class="btn btn-md btn-outline-dark">${text || ""}</button>
    </a>`
  }

  const button = {
    visit: getButtonTemplate(data?.buttons.primary, "visit_website"),
    watch: getButtonTemplate(data?.buttons.secondary, "watch_now"),
    vote: getButtonTemplate(data?.buttons.tertiary, "vote")
  }

  const getImage = (image: string | undefined, defaultImage: string) => {
    return !image?.length
      ? `data:image/png;base64,${defaultImage}`
      : encodeURI(image ?? "");
  }

  const imageUrl = {
    bannerBackground: getImage(data?.bannerImageSrc, defaultBannerImage),
    channel: getImage(data?.channelImageSrc, defaultChannelImage)
  };

  const DataTemplate = `
    <div class="channel-popup-header">
      <div class="channel-popup-header-background" style="background-image: url(${imageUrl.bannerBackground})">
        <div class="channel-popup-header-logo">
          <img src="${imageUrl.channel}" />
        </div>
      </div>
      <h3>${data?.header || ""} (Channel ${data?.channelNumber})</h3>
    </div>
    <div class="channel-popup-body">
      <p>${data?.bodyText || ""}</p>
    </div>
    <div class="channel-popup-footer">
      <div class="channel-popup-footer-action">
        ${button.visit} 
        ${button.watch} 
        ${button.vote} 
      </div>
    </div>
  `;

  return _getTemplate(DataTemplate);
}